export const ActionTypes = {
  start: 'START',
  complete: 'COMPLETE',
  fail: 'FAIL',
};

export const initialState = {
  isLoading: false,
  error: null,
  data: null, // this stores raw response data
  query: null,
  hasFilteredOutResults: false,
};

export function searchReducer(state, action) {
  switch (action.type) {
    case ActionTypes.start:
      return {
        ...state,
        isLoading: true,
        error: null,
        query: action.query,
      };
    case ActionTypes.complete:
      if (state.query === action.query) {
        return {
          isLoading: false,
          data: action.data,
          hasFilteredOutResults: action.hasFilteredOutResults,
          error: null,
        };
      }
      return state;
    case ActionTypes.fail:
      if (state.query === action.query) {
        return {
          isLoading: false,
          data: action.data,
          error: action.error,
        };
      }
      return state;
    default: throw new Error(`Invalid search action: ${action.type}`);
  }
}
